import React, { useCallback, useEffect, useRef } from 'react';
export const useAnimationObserver = () => {
  const observerRef = useRef<IntersectionObserver | null>(null);
  const setupAnimations = useCallback(() => {
    // Clean up any existing observer
    if (observerRef.current) {
      observerRef.current.disconnect();
    }
    // Create new IntersectionObserver
    observerRef.current = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        // Add appear class when element is visible
        if (entry.isIntersecting) {
          if (entry.target.classList.contains('fade-item')) {
            entry.target.classList.add('appear');
          }
          // Handle stagger animations
          if (entry.target.classList.contains('stagger-container')) {
            const staggerItems = entry.target.querySelectorAll('.stagger-item');
            staggerItems.forEach((item, index) => {
              setTimeout(() => {
                item.classList.add('appear');
              }, index * 100); // 100ms delay between each item
            });
          }
          // Stop observing after animation is triggered
          observerRef.current?.unobserve(entry.target);
        }
      });
    }, {
      root: null,
      rootMargin: '0px',
      threshold: 0.1 // trigger when 10% of the element is visible
    });
    // Start observing elements
    const fadeElements = document.querySelectorAll('.fade-item, .stagger-container, .observer-element');
    fadeElements.forEach(element => {
      observerRef.current?.observe(element);
    });
    // Return cleanup function
    return () => {
      observerRef.current?.disconnect();
    };
  }, []);
  // Clean up observer on component unmount
  useEffect(() => {
    return () => {
      if (observerRef.current) {
        observerRef.current.disconnect();
      }
    };
  }, []);
  return {
    setupAnimations
  };
};